import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import Swal from 'sweetalert2';
import { debtorsResponse } from '../../../interface/data.interface';
import { MatTableDataSource } from '@angular/material/table';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CompaniesFactoringService } from 'src/app/pages/dashboards/factoring/services/companies-factoring.service';
import { Router } from '@angular/router';
import { ChartComponent } from 'ng-apexcharts';
import { AddDebtorModalComponent } from 'src/app/pages/dashboards/modals/add-debtor-modal/add-debtor-modal.component';

@Component({
  selector: 'app-all-debtors-table',
  templateUrl: './all-debtors-table.component.html',
  styleUrls: ['./all-debtors-table.component.scss']
})
export class AllDebtorsTableComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public dataSource!: MatTableDataSource<any>;
  @Output() changePagination = new EventEmitter<any>();
  @Output() changeSorting = new EventEmitter<string>;
  @Output() actualizarData = new EventEmitter<string>;
  @Input() recieveData: PageResult<debtorsResponse>;
  @Input() booleanFlag: boolean;
  @Input() booleanText: boolean;

  displayedColumns: string[] = [
    'name',
    'rut',
    'lista'
  ];

  constructor(private router: Router, private dialog: MatDialog, private serviceDebtorList: CompaniesFactoringService,) { }

  ngOnInit() {
    this.setDataSource(this.recieveData);
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.recieveData);
    if (changes['recieveData']) {
      const newDeptorsFilter = changes['recieveData'].currentValue;
      this.setDataSource(newDeptorsFilter);
    }
  }

  private setDataSource(dataSource: PageResult<debtorsResponse>) {
    const {sortColumn, sortDirection} = dataSource;
    this.dataSource = new MatTableDataSource<debtorsResponse>(dataSource?.results);
    this.paginator.length = dataSource?.totalRows;
    if(sortColumn && sortDirection){
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  public changePaginationTable(event: PageEvent) {
    this.changePagination.emit({
      page: event.pageIndex + 1,
      size: event.pageSize,
    });
  }

  public changeSortingTable(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSorting.emit('');
      return;
    }
    const sortOrder = `${sortState.active}_${sortState.direction}`;
    this.changeSorting.emit(sortOrder);
  }

  public dealDialogOpen(args: any): void {
    this.router.navigate(['dashboards/files-clients'], {
      queryParams: { client: +args },
    });
  }

  addDebtor() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'modalAddClient';
    const dialogRef = this.dialog.open(AddDebtorModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      console.log('Modal Cerrado');
    });
  }

  addFavorite(companyId: number) {
    this.serviceDebtorList.updateDebtorFavorite(companyId).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: "Compañia Agregada a Deudres Favoritos"
        })
        this.actualizarData.emit("update");
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage
        });
      }
    })
  }

  addBlackList(companyId: number) {
    this.serviceDebtorList.updateDebtorBalackList(companyId).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: "Compañia Agregada a Lista Negra"
        })
        this.actualizarData.emit("update");
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage
        });
      }
    })
  }

  openDialogConfirm(rut: string) {
    const id = rut.replaceAll('.', '').split('-')[0];
    const companyId = Number.parseInt(id);
    Swal.fire({
      titleText: '¿Deseas Quitar al Cliente de la Lista?',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Quitar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceDebtorList.updateDebtorFavorite(companyId).subscribe({
          next: (res) => {
            Swal.fire({
              title: `Quitado Exitosamnete`,
              icon: 'success',
            });
            this.actualizarData.emit("update");
          },
          error: (err) => {
            console.log(err);
            Swal.fire({
              title: `Error al Quitar de la Lista`,
              icon: 'error',
              text: err.error.resultMessage
            });
          }
        })
      }
    });
  }

}
